import Vue from 'vue'
import { mapActions } from 'vuex'

const KEY_BACKSPACE = 8
const KEY_DELETE = 46
const KEY_F2 = 113
const KEY_ENTER = 13
const KEY_TAB = 9

export default Vue.extend({
  template: '<input :ref="\'input\'" @keydown="onKeyDown($event)" v-model="value"/>',
  data() {
    return {
      value: '',
      cancelBeforeStart: true,
      highlightAllOnFocus: true
    }
  },
  methods: {
    ...mapActions({
      pushToasts: 'toasts/pushToasts'
    }),
    getValue() {
      return this.params.nullable && !this.value && this.value !== 0 ? null : +this.value
    },

    isCancelBeforeStart() {
      return this.cancelBeforeStart
    },

    setInitialState(params) {
      let startValue
      let highlightAllOnFocus = true

      if (params.keyPress === KEY_BACKSPACE || params.keyPress === KEY_DELETE) {
        startValue = ''
      } else if (params.charPress) {
        startValue = params.charPress
        highlightAllOnFocus = false
      } else {
        startValue = params.value
        if (params.keyPress === KEY_F2) {
          highlightAllOnFocus = false
        }
      }

      this.value = startValue
      this.highlightAllOnFocus = highlightAllOnFocus
    },

    isCancelAfterEnd() {
      const max = 'max' in this.params ? this.params.max : 1000000
      if (this.value > max) {
        this.pushToasts({
          error: true,
          title: 'Ошибка ввода',
          message: `Превышено максимальное значение - ${max}`,
          time: 3
        })
      }
      return this.value > max
    },

    onKeyDown(event) {
      if (this.isLeftOrRight(event) || this.deleteOrBackspace(event)) {
        event.stopPropagation()
        return
      }

      if (
        !this.finishedEditingPressed(event)
        && !this.isKeyPressedNumeric(event)
      ) {
        if (event.preventDefault) event.preventDefault()
      }
    },

    getCharCodeFromEvent(event) {
      // eslint-disable-next-line no-param-reassign
      event = event || window.event
      return typeof event.which === 'undefined' ? event.keyCode : event.which
    },

    isCharNumeric(charStr) {
      return /\d/.test(charStr)
    },

    isKeyPressedNumeric(event) {
      const charCode = this.getCharCodeFromEvent(event)
      return (charCode >= 48 && charCode <= 57) || (charCode >= 96 && charCode <= 105)
    },

    finishedEditingPressed(event) {
      const charCode = this.getCharCodeFromEvent(event)
      return charCode === KEY_ENTER || charCode === KEY_TAB
    },

    deleteOrBackspace(event) {
      return (
        [KEY_DELETE, KEY_BACKSPACE].indexOf(this.getCharCodeFromEvent(event))
        > -1
      )
    },

    isLeftOrRight(event) {
      return [37, 39].indexOf(this.getCharCodeFromEvent(event)) > -1
    }
  },

  created() {
    this.setInitialState(this.params)

    // only start edit if key pressed is a number, not a letter
    this.cancelBeforeStart = this.params.charPress
      && '1234567890'.indexOf(this.params.charPress) < 0
  },
  mounted() {
    Vue.nextTick(() => {
      if (this.$refs.input) {
        if ('min' in this.params) {
          this.$refs.input.min = this.params.min
        }
        if ('max' in this.params) {
          this.$refs.input.max = this.params.max
        }
        this.$refs.input.focus()
        if (this.highlightAllOnFocus) {
          this.$refs.input.select()

          this.highlightAllOnFocus = false
        } else {
          const length = this.$refs.input.value
            ? this.$refs.input.value.length
            : 0
          if (length > 0) {
            this.$refs.input.setSelectionRange(length, length)
          }
        }
        this.$refs.input.focus()
      }
    })
  }
})
